/* eslint-disable react-refresh/only-export-components */
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AdminLayout } from '@/components/layout/admin-layout';
import { MarketingLayout } from '@/components/layout/marketing-layout';
import { Can } from '@/components/auth/can';
import { ForbiddenView } from '@/components/auth/forbidden-view';
import { HomeGate } from '@/components/auth/home-gate';
import {
  CATALOG_TABS,
  CUSTOMERS_TABS,
  DASHBOARD_TABS,
  FINANCE_TABS,
  LOGISTICS_TABS,
  ORDERS_TABS,
  PAYMENTS_TABS,
  SHORT_LINKS_TABS,
  SectionTabsLayout,
} from '@/components/layout/section-tabs-layout';
import { AdminAdministrationPage } from '@/pages/admin/administration';
import { AdminAdsPage } from '@/pages/admin/ads';
import { AdminMarketingGeneratorPage } from '@/pages/admin/marketing-generator';
import { AdminShortLinkDetailPage } from '@/pages/admin/short-link-detail';
import { AdminShortLinksPage } from '@/pages/admin/short-links';
import { AdminShortLinksStatsPage } from '@/pages/admin/short-links-stats';
import { AdminAttributesPage } from '@/pages/admin/attributes';
import { AdminBrandsPage } from '@/pages/admin/brands';
import { AdminCatalogPage } from '@/pages/admin/catalog';
import { AdminCatalogAiPage } from '@/pages/admin/catalog-ai';
import { AdminCatalogReviewPage } from '@/pages/admin/catalog-review';
import { AdminCategoriesPage } from '@/pages/admin/categories';
import { AdminMarketingBannersPage } from '@/pages/admin/marketing/banners';
import { AdminMarketingCalendrierPage } from '@/pages/admin/marketing/calendrier';
import { AdminMarketingMagPage } from '@/pages/admin/marketing/mag';
import { AdminMarketingNewslettersPage } from '@/pages/admin/marketing/newsletters';
import { AdminMarketingOverviewPage } from '@/pages/admin/marketing/overview';
import { AdminMarketingPushPage } from '@/pages/admin/marketing/push';
import { AdminMarketingWhatsappPage } from '@/pages/admin/marketing/whatsapp';
import { AdminCmsHomePage } from '@/pages/admin/cms/home';
import { AdminCmsPagesPage } from '@/pages/admin/cms/pages';
import { AdminCmsPromisesPage } from '@/pages/admin/cms/promises';
import { AdminCmsSeoPage } from '@/pages/admin/cms/seo';
import { AdminCustomerCreatePage } from '@/pages/admin/customer-create';
import { AdminCustomerDetailPage } from '@/pages/admin/customer-detail';
import { AdminCustomerGdprPage } from '@/pages/admin/customer-gdpr';
import { AdminCustomerLoyaltyPage } from '@/pages/admin/customer-loyalty';
import { AdminCustomerReferralsPage } from '@/pages/admin/customer-referrals';
import { AdminCustomerSegmentsPage } from '@/pages/admin/customer-segments';
import { AdminCustomersPage } from '@/pages/admin/customers';
import { AdminCustomersStatsPage } from '@/pages/admin/customers-stats';
import { AdminDeliveryZonesPage } from '@/pages/admin/delivery-zones';
import { AdminFinancePage } from '@/pages/admin/finance';
import { AdminAuditPage } from '@/pages/admin/finance-pages/audit';
import { AdminBudgetsPage } from '@/pages/admin/finance-pages/budgets';
import { AdminChartPage } from '@/pages/admin/finance-pages/chart';
import { AdminCreditNotesPage } from '@/pages/admin/finance-pages/credit-notes';
import { AdminExportsPage } from '@/pages/admin/finance-pages/exports';
import { AdminInvoiceCreatePage } from '@/pages/admin/finance-pages/invoice-create';
import { AdminInvoiceDetailPage } from '@/pages/admin/finance-pages/invoice-detail';
import { AdminInvoicesPage } from '@/pages/admin/finance-pages/invoices';
import { AdminJournalsPage } from '@/pages/admin/finance-pages/journals';
import { AdminStatementsPage } from '@/pages/admin/finance-pages/statements';
import { AdminVatPage } from '@/pages/admin/finance-pages/vat';
import { ForgotPasswordPage } from '@/pages/admin/forgot-password';
import { AdminHubsPage } from '@/pages/admin/hubs';
import { AdminImportExportPage } from '@/pages/admin/import-export';
import { LoginPage } from '@/pages/admin/login';
import { AdminLogisticsPage } from '@/pages/admin/logistics';
import { AdminMediaLibraryPage } from '@/pages/admin/media-library';
import { NotFoundPage } from '@/pages/admin/not-found';
import { AdminNotificationsPage } from '@/pages/admin/notifications';
import { AdminOrderCreatePage } from '@/pages/admin/order-create';
import { AdminOrderDetailPage } from '@/pages/admin/order-detail';
import { AdminOrdersPage } from '@/pages/admin/orders';
import { AdminOrdersSearchPage } from '@/pages/admin/orders-search';
import { AdminOrdersStatsPage } from '@/pages/admin/orders-stats';
import { AdminPaymentsPage } from '@/pages/admin/payments';
import { AdminCodPage } from '@/pages/admin/payments-pages/cod';
import { AdminDisputesPage } from '@/pages/admin/payments-pages/disputes';
import { AdminMomoLivePage } from '@/pages/admin/payments-pages/momo-live';
import { AdminPaymentDetailPage } from '@/pages/admin/payments-pages/payment-detail';
import { AdminBankAccountsPage } from '@/pages/admin/payments-pages/bank-accounts';
import { AdminProvidersPage } from '@/pages/admin/payments-pages/providers';
import { AdminReconciliationPage } from '@/pages/admin/payments-pages/reconciliation';
import { AdminRefundsPage } from '@/pages/admin/payments-pages/refunds';
import { AdminProductDetailPage } from '@/pages/admin/product-detail';
import { AdminProductCreatePage, AdminProductEditPage } from '@/pages/admin/product-edit';
import { AdminProductReviewsPage } from '@/pages/admin/product-reviews';
import { MfaMethodPickerPage } from '@/pages/admin/profile/mfa/mfa-method';
import { MfaRecoveryCodesPage } from '@/pages/admin/profile/mfa/mfa-recovery-codes';
import { MfaTotpSetupPage } from '@/pages/admin/profile/mfa/mfa-totp-setup';
import { ProfileIdentityPage } from '@/pages/admin/profile/profile-identity';
import { ProfileLayout } from '@/pages/admin/profile/profile-layout';
import { ProfilePreferencesPage } from '@/pages/admin/profile/profile-preferences';
import { ProfileSecurityPage } from '@/pages/admin/profile/profile-security';
import { ProfileSessionsPage } from '@/pages/admin/profile/profile-sessions';
import { AdminPromotionsPage } from '@/pages/admin/promotions';
import { AdminNjangiPage } from '@/pages/admin/njangi';
import { AdminQuotesPage } from '@/pages/admin/quotes';
import { AdminReportingPage } from '@/pages/admin/reporting';
import { ResetPasswordPage } from '@/pages/admin/reset-password';
import { AdminReturnDetailPage } from '@/pages/admin/return-detail';
import { AdminReturnsPage } from '@/pages/admin/returns';
import { AdminSiteLaunchPage } from '@/pages/admin/site-launch';
import { AdminSocialPage } from '@/pages/admin/social';
import { AdminSuppliersPage } from '@/pages/admin/suppliers';
import { AdminSupportPage } from '@/pages/admin/support';
import { TwoFactorPage } from '@/pages/admin/two-factor';
import { ActivationPage } from '@/pages/admin/users/activation';
import { UserDetailPage } from '@/pages/admin/users/user-detail';
import { UserCreatePage, UserEditPage } from '@/pages/admin/users/user-form';
import { useAuthStore } from '@/stores/auth.store';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const authed = useAuthStore((s) => s.isAuthenticated);
  if (!authed) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function guard(anyOf: string[], element: React.ReactNode) {
  return (
    <Can anyOf={anyOf} fallback={<ForbiddenView />}>
      {element}
    </Can>
  );
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/login/2fa', element: <TwoFactorPage /> },
  { path: '/login/mot-de-passe-oublie', element: <ForgotPasswordPage /> },
  { path: '/login/nouveau-mot-de-passe', element: <ResetPasswordPage /> },
  { path: '/activation', element: <ActivationPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AdminLayout />
      </RequireAuth>
    ),
    children: [
      {
        // Section Tableau de bord : sous-navigation par onglets
        element: <SectionTabsLayout tabs={DASHBOARD_TABS} testId="dashboard-tabs" />,
        children: [
          { index: true, element: <HomeGate /> },
          {
            path: 'reporting',
            element: guard(
              ['REPORTING.DIRECTION.READ', 'FINANCE.READ', 'LOGISTICS.READ', 'SUPPORT.READ'],
              <AdminReportingPage />,
            ),
          },
        ],
      },
      { path: 'notifications', element: <AdminNotificationsPage /> },
      {
        // Section Commandes : sous-navigation par onglets
        element: <SectionTabsLayout tabs={ORDERS_TABS} testId="orders-tabs" />,
        children: [
          { path: 'commandes', element: <AdminOrdersPage /> },
          { path: 'commandes/recherche', element: <AdminOrdersSearchPage /> },
          {
            path: 'commandes/statistiques',
            element: <AdminOrdersStatsPage />,
          },
          { path: 'retours', element: <AdminReturnsPage /> },
        ],
      },
      { path: 'commandes/nouvelle', element: <AdminOrderCreatePage /> },
      { path: 'commandes/:id', element: <AdminOrderDetailPage /> },
      { path: 'retours/:id', element: <AdminReturnDetailPage /> },
      {
        // Section Catalogue : sous-navigation par onglets
        element: <SectionTabsLayout tabs={CATALOG_TABS} testId="catalog-tabs" />,
        children: [
          { path: 'catalogue', element: <AdminCatalogPage /> },
          { path: 'categories', element: <AdminCategoriesPage /> },
          { path: 'marques', element: <AdminBrandsPage /> },
          { path: 'attributs', element: <AdminAttributesPage /> },
          {
            path: 'catalogue/import-export',
            element: <AdminImportExportPage />,
          },
          { path: 'catalogue/medias', element: <AdminMediaLibraryPage /> },
          { path: 'avis-produits', element: <AdminProductReviewsPage /> },
          { path: 'catalogue/assistant-ia', element: <AdminCatalogAiPage /> },
        ],
      },
      // Hors du groupe à onglets : la revue occupe tout l'écran, sans
      // sous-navigation — on n'y vient que pour enchaîner des fiches.
      { path: 'catalogue/revue', element: <AdminCatalogReviewPage /> },
      { path: 'catalogue/nouveau', element: <AdminProductCreatePage /> },
      { path: 'catalogue/:id/modifier', element: <AdminProductEditPage /> },
      { path: 'catalogue/:id', element: <AdminProductDetailPage /> },
      { path: 'parametres/hubs', element: <AdminHubsPage /> },
      {
        // Section Clients : sous-navigation par onglets
        element: <SectionTabsLayout tabs={CUSTOMERS_TABS} testId="customers-tabs" />,
        children: [
          { path: 'clients', element: guard(['CUSTOMERS.READ'], <AdminCustomersPage />) },
          {
            // Les segments ont rejoint « Marketing & Contenus » : un segment
            // sert à cibler une campagne, pas à administrer une fiche client.
            // L'ancienne adresse reste valable et redirige.
            path: 'clients/segments',
            element: <Navigate to="/marketing/segments" replace />,
          },
          {
            path: 'clients/fidelite',
            element: guard(['CUSTOMERS.READ'], <AdminCustomerLoyaltyPage />),
          },
          {
            path: 'clients/parrainage',
            element: guard(['CUSTOMERS.READ'], <AdminCustomerReferralsPage />),
          },
          {
            path: 'clients/rgpd',
            element: guard(['CUSTOMERS.READ', 'CUSTOMERS.GDPR.HANDLE'], <AdminCustomerGdprPage />),
          },
          {
            path: 'clients/statistiques',
            element: guard(['CUSTOMERS.READ'], <AdminCustomersStatsPage />),
          },
        ],
      },
      {
        path: 'clients/nouveau',
        element: guard(['CUSTOMERS.WRITE', 'CUSTOMERS.READ'], <AdminCustomerCreatePage />),
      },
      {
        path: 'clients/:id',
        element: guard(['CUSTOMERS.READ'], <AdminCustomerDetailPage />),
      },
      {
        // Section Logistique : sous-navigation par onglets
        element: <SectionTabsLayout tabs={LOGISTICS_TABS} testId="logistics-tabs" />,
        children: [
          { path: 'logistique', element: guard(['LOGISTICS.READ'], <AdminLogisticsPage />) },
          {
            path: 'logistique/zones',
            element: guard(['LOGISTICS.READ'], <AdminDeliveryZonesPage />),
          },
        ],
      },
      { path: 'fournisseurs', element: <AdminSuppliersPage /> },
      { path: 'support', element: guard(['SUPPORT.READ'], <AdminSupportPage />) },
      { path: 'devis', element: <AdminQuotesPage /> },
      {
        // Section Paiements : sous-navigation par onglets
        element: <SectionTabsLayout tabs={PAYMENTS_TABS} testId="payments-tabs" />,
        children: [
          { path: 'paiements', element: <AdminPaymentsPage /> },
          { path: 'paiements/momo-live', element: <AdminMomoLivePage /> },
          {
            path: 'paiements/remboursements',
            element: <AdminRefundsPage />,
          },
          {
            path: 'paiements/rapprochement',
            element: <AdminReconciliationPage />,
          },
          { path: 'paiements/litiges', element: <AdminDisputesPage /> },
          { path: 'paiements/prestataires', element: <AdminProvidersPage /> },
          {
            path: 'paiements/comptes-bancaires',
            element: <AdminBankAccountsPage />,
          },
          { path: 'paiements/cod', element: <AdminCodPage /> },
        ],
      },
      { path: 'paiements/:id', element: <AdminPaymentDetailPage /> },
      {
        // Section Comptabilité : sous-navigation par onglets
        element: <SectionTabsLayout tabs={FINANCE_TABS} testId="finance-tabs" />,
        children: [
          { path: 'finance', element: guard(['FINANCE.READ'], <AdminFinancePage />) },
          { path: 'finance/factures', element: guard(['FINANCE.READ'], <AdminInvoicesPage />) },
          {
            path: 'finance/avoirs',
            element: guard(['FINANCE.READ', 'FINANCE.CREDIT_NOTE.ISSUE'], <AdminCreditNotesPage />),
          },
          { path: 'finance/journaux', element: guard(['FINANCE.READ'], <AdminJournalsPage />) },
          { path: 'finance/plan-comptable', element: guard(['FINANCE.READ'], <AdminChartPage />) },
          { path: 'finance/tva', element: guard(['FINANCE.READ'], <AdminVatPage />) },
          {
            path: 'finance/exports',
            element: guard(['FINANCE.EXPORT', 'FINANCE.EXPORT.ACCOUNTING'], <AdminExportsPage />),
          },
          {
            path: 'finance/etats',
            element: guard(['FINANCE.STATEMENTS', 'FINANCE.READ'], <AdminStatementsPage />),
          },
          {
            path: 'finance/budgets',
            element: guard(['FINANCE.BUDGET.EDIT', 'FINANCE.READ'], <AdminBudgetsPage />),
          },
          { path: 'finance/audit', element: guard(['FINANCE.AUDIT'], <AdminAuditPage />) },
        ],
      },
      {
        path: 'finance/factures/nouvelle',
        element: guard(['FINANCE.READ'], <AdminInvoiceCreatePage />),
      },
      {
        path: 'finance/factures/:id',
        element: guard(['FINANCE.READ'], <AdminInvoiceDetailPage />),
      },
      {
        /**
         * Marketing & Contenus — dix-sept écrans sous une colonne de
         * sous-navigation commune (voir MarketingLayout).
         *
         * Les adresses sont inchangées : /cms, /promotions, /njangi,
         * /reseaux-sociaux, /publicites, /liens-courts et
         * /parametres/lancement répondent comme avant. Seule la barre
         * latérale a maigri, et aucun favori ne casse.
         */
        element: <MarketingLayout />,
        children: [
          {
            path: 'marketing',
            element: guard(
              ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
              <AdminMarketingOverviewPage />,
            ),
          },
          {
            path: 'marketing/bannieres',
            element: guard(
              ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
              <AdminMarketingBannersPage />,
            ),
          },
          {
            path: 'marketing/mag',
            element: guard(
              ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
              <AdminMarketingMagPage />,
            ),
          },
          {
            path: 'marketing/newsletters',
            element: guard(
              ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
              <AdminMarketingNewslettersPage />,
            ),
          },
          {
            path: 'marketing/push',
            element: guard(
              ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
              <AdminMarketingPushPage />,
            ),
          },
          {
            path: 'marketing/whatsapp',
            element: guard(
              ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
              <AdminMarketingWhatsappPage />,
            ),
          },
          {
            path: 'marketing/calendrier',
            element: guard(
              ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
              <AdminMarketingCalendrierPage />,
            ),
          },
          {
            path: 'marketing/segments',
            element: guard(
              ['CUSTOMERS.READ', 'MARKETING.CMS.READ'],
              <AdminCustomerSegmentsPage />,
            ),
          },
          { path: 'marketing/generateur', element: <AdminMarketingGeneratorPage /> },
          { path: 'cms', element: <AdminCmsHomePage /> },
          { path: 'cms/pages', element: <AdminCmsPagesPage /> },
          { path: 'cms/engagements', element: <AdminCmsPromisesPage /> },
          { path: 'cms/referencement', element: <AdminCmsSeoPage /> },
          { path: 'reseaux-sociaux', element: <AdminSocialPage /> },
          { path: 'publicites', element: <AdminAdsPage /> },
          { path: 'promotions', element: <AdminPromotionsPage /> },
          { path: 'njangi', element: <AdminNjangiPage /> },
          { path: 'parametres/lancement', element: <AdminSiteLaunchPage /> },
          {
            // Liens courts : deux onglets en pastilles À L'INTÉRIEUR de la
            // colonne marketing — la liste et ses statistiques sont deux vues
            // du même objet, pas deux entrées de navigation.
            element: <SectionTabsLayout tabs={SHORT_LINKS_TABS} testId="short-links-tabs" />,
            children: [
              {
                path: 'liens-courts',
                element: guard(
                  ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
                  <AdminShortLinksPage />,
                ),
              },
              {
                path: 'liens-courts/statistiques',
                element: guard(
                  ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
                  <AdminShortLinksStatsPage />,
                ),
              },
            ],
          },
        ],
      },
      // Le détail vit HORS du layout à onglets, comme les autres pages de détail.
      {
        path: 'liens-courts/:id',
        element: guard(
          ['MARKETING.CMS.READ', 'MARKETING.CMS.WRITE'],
          <AdminShortLinkDetailPage />,
        ),
      },
      { path: 'administration', element: <AdminAdministrationPage /> },
      {
        path: 'administration/utilisateurs/nouveau',
        element: <UserCreatePage />,
      },
      {
        path: 'administration/utilisateurs/:id/modifier',
        element: <UserEditPage />,
      },
      { path: 'administration/utilisateurs/:id', element: <UserDetailPage /> },
      {
        path: 'profil',
        element: <ProfileLayout />,
        children: [
          { index: true, element: <ProfileIdentityPage /> },
          { path: 'securite', element: <ProfileSecurityPage /> },
          { path: 'sessions', element: <ProfileSessionsPage /> },
          { path: 'preferences', element: <ProfilePreferencesPage /> },
        ],
      },
      { path: 'profil/securite/2fa/methode', element: <MfaMethodPickerPage /> },
      { path: 'profil/securite/2fa/totp', element: <MfaTotpSetupPage /> },
      {
        path: 'profil/securite/2fa/recovery-codes',
        element: <MfaRecoveryCodesPage />,
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
